module.exports = {
	"config": {
		"blogTitle": "Ride Safe San Diego",
		"authorName": "Jordan Kohl",
		"linkPrefix": "/san-diego-downtown-mobility-plan"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"path": "_template.js",
				"isAbsolute": false,
				"absolute": "/Users/simpixelated/Dev/san-diego-downtown-mobility-plan/_template.js",
				"root": "",
				"dirname": "",
				"basename": "_template.js",
				"extname": ".js",
				"name": "_template",
				"ext": "js"
			},
			"requirePath": "_template.js",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"path": "404.md",
				"isAbsolute": false,
				"absolute": "/Users/simpixelated/Dev/san-diego-downtown-mobility-plan/404.md",
				"root": "",
				"dirname": "",
				"basename": "404.md",
				"extname": ".md",
				"name": "404",
				"ext": "md"
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html"
			}
		},
		{
			"file": {
				"path": "content/but-why-bike-lanes.md",
				"isAbsolute": false,
				"absolute": "/Users/simpixelated/Dev/san-diego-downtown-mobility-plan/content/but-why-bike-lanes.md",
				"root": "",
				"dirname": "content",
				"basename": "but-why-bike-lanes.md",
				"extname": ".md",
				"name": "but-why-bike-lanes",
				"ext": "md"
			},
			"requirePath": "content/but-why-bike-lanes.md",
			"path": "/but-why-bike-lanes/",
			"data": {
				"title": "But Why Bike Lanes?",
				"date": "2016-03-13T23:46:37.121Z",
				"layout": "post",
				"readNext": "/upcoming-advocacy-opportunities/",
				"path": "/but-why-bike-lanes/"
			}
		},
		{
			"file": {
				"path": "content/letters/open-letter-city-council.md",
				"isAbsolute": false,
				"absolute": "/Users/simpixelated/Dev/san-diego-downtown-mobility-plan/content/letters/open-letter-city-council.md",
				"root": "",
				"dirname": "content/letters",
				"basename": "open-letter-city-council.md",
				"extname": ".md",
				"name": "open-letter-city-council",
				"ext": "md"
			},
			"requirePath": "content/letters/open-letter-city-council.md",
			"path": "/open-letter-to-city-council/",
			"data": {
				"title": "Open Letter to City Council",
				"date": "2016-06-20T20:44:12.823Z",
				"layout": "post",
				"path": "/open-letter-to-city-council/",
				"readNext": "/open-letter-to-planning-commission/"
			}
		},
		{
			"file": {
				"path": "content/letters/open-letter-planning-commission.md",
				"isAbsolute": false,
				"absolute": "/Users/simpixelated/Dev/san-diego-downtown-mobility-plan/content/letters/open-letter-planning-commission.md",
				"root": "",
				"dirname": "content/letters",
				"basename": "open-letter-planning-commission.md",
				"extname": ".md",
				"name": "open-letter-planning-commission",
				"ext": "md"
			},
			"requirePath": "content/letters/open-letter-planning-commission.md",
			"path": "/open-letter-to-planning-commission/",
			"data": {
				"title": "Open Letter to Planning Commission",
				"date": "2016-04-29T01:51:41.917Z",
				"layout": "post",
				"path": "/open-letter-to-planning-commission/",
				"readNext": "/open-letter-to-councilmember-zapf/"
			}
		},
		{
			"file": {
				"path": "content/letters/open-letter-to-councilmember-zapf.md",
				"isAbsolute": false,
				"absolute": "/Users/simpixelated/Dev/san-diego-downtown-mobility-plan/content/letters/open-letter-to-councilmember-zapf.md",
				"root": "",
				"dirname": "content/letters",
				"basename": "open-letter-to-councilmember-zapf.md",
				"extname": ".md",
				"name": "open-letter-to-councilmember-zapf",
				"ext": "md"
			},
			"requirePath": "content/letters/open-letter-to-councilmember-zapf.md",
			"path": "/open-letter-to-councilmember-zapf/",
			"data": {
				"title": "Open Letter to Councilmember Lorie Zapf",
				"date": "2016-04-22T14:21:14.049Z",
				"layout": "post",
				"readNext": "/upcoming-advocacy-opportunities/",
				"path": "/open-letter-to-councilmember-zapf/"
			}
		},
		{
			"file": {
				"path": "content/letters/open-letter-to-mayor-faulconer.md",
				"isAbsolute": false,
				"absolute": "/Users/simpixelated/Dev/san-diego-downtown-mobility-plan/content/letters/open-letter-to-mayor-faulconer.md",
				"root": "",
				"dirname": "content/letters",
				"basename": "open-letter-to-mayor-faulconer.md",
				"extname": ".md",
				"name": "open-letter-to-mayor-faulconer",
				"ext": "md"
			},
			"requirePath": "content/letters/open-letter-to-mayor-faulconer.md",
			"path": "/open-letter-to-mayor-faulconer/",
			"data": {
				"title": "Open Letter to Mayor Kevin Faulconer",
				"date": "2016-03-12T22:40:32.169Z",
				"layout": "post",
				"readNext": "/but-why-bike-lanes/",
				"path": "/open-letter-to-mayor-faulconer/"
			}
		},
		{
			"file": {
				"path": "content/upcoming-advocacy-opportunities.md",
				"isAbsolute": false,
				"absolute": "/Users/simpixelated/Dev/san-diego-downtown-mobility-plan/content/upcoming-advocacy-opportunities.md",
				"root": "",
				"dirname": "content",
				"basename": "upcoming-advocacy-opportunities.md",
				"extname": ".md",
				"name": "upcoming-advocacy-opportunities",
				"ext": "md"
			},
			"requirePath": "content/upcoming-advocacy-opportunities.md",
			"path": "/upcoming-advocacy-opportunities/",
			"data": {
				"title": "Upcoming Advocacy Opportunities",
				"date": "2016-04-12T22:12:03.284Z",
				"layout": "post",
				"readNext": "/open-letter-to-planning-commission/",
				"path": "/upcoming-advocacy-opportunities/"
			}
		},
		{
			"file": {
				"path": "index.js",
				"isAbsolute": false,
				"absolute": "/Users/simpixelated/Dev/san-diego-downtown-mobility-plan/index.js",
				"root": "",
				"dirname": "",
				"basename": "index.js",
				"extname": ".js",
				"name": "index",
				"ext": "js"
			},
			"requirePath": "index.js",
			"path": "/",
			"data": {}
		}
	]
}


/*****************
 ** WEBPACK FOOTER
 ** ../config.toml
 ** module id = 341
 ** module chunks = 0
 **/